<div class="title">
  <div class="heading">
    <mat-icon svgIcon="ai-meeting-analysis-icon" class="ai-icon"></mat-icon>
    <span>{{ 'SCHEDULE_BOT.JOIN_MEETING' | translate }}</span>
  </div>
  <div class="settings">
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider></mat-divider>
<div class="atlas-navbar__container">
  <div class="container">
    <p>{{ 'SCHEDULE_BOT.DESCRIPTION' | translate }}</p>
    <div class="action-container">
      <glxy-form-field bottomSpacing="none" class="grow">
        <glxy-label>{{ 'SCHEDULE_BOT.MEETING_URL' | translate }}</glxy-label>
        <input
          [placeholder]="'SCHEDULE_BOT.PLACEHOLDER' | translate"
          type="text"
          matInput
          [formControl]="formControl"
        />
      </glxy-form-field>
      <button mat-raised-button color="primary" (click)="joinMeeting()">
        {{ 'SCHEDULE_BOT.SEND_NOW' | translate }}
      </button>
    </div>
  </div>
</div>
